import { IRootState } from './index';
import { ISchoolCoordinates, School, SchoolState } from './school.types';

export const selectSchool = ({ school }: IRootState): SchoolState => school;

export const selectCurrentSchool = (state: IRootState): School | undefined => selectSchool(state).currentSchool;

export const selectSchoolCoordinatesList = (state: IRootState): ISchoolCoordinates[] =>
  selectSchool(state).schoolCoordinatesList;
